module.exports = __webpack_public_path__ + "img/subject_banner10.fef2d606.png";